/**
 * @generated SignedSource<<08bbdfb732a0e903037634e82b2cebab>>
 * @relayHash c0a7532c77f00a6d3db89afbba6c2124
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e3afe4be4952ff1385de921ea89e96ad689b38bd27c628e4ceacc511c99519eb

import type { ConcreteRequest } from 'relay-runtime';
export type SmartCreatePageEditorDataWrapperComponentQuery$variables = {
  contentId: string;
};
export type SmartCreatePageEditorDataWrapperComponentQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly body: {
        readonly atlas_doc_format: {
          readonly value: string | null;
        } | null;
      } | null;
      readonly id: string | null;
      readonly space: {
        readonly alias: string | null;
        readonly id: string | null;
        readonly key: string | null;
      } | null;
      readonly title: string | null;
    } | null> | null;
  } | null;
};
export type SmartCreatePageEditorDataWrapperComponentQuery = {
  response: SmartCreatePageEditorDataWrapperComponentQuery$data;
  variables: SmartCreatePageEditorDataWrapperComponentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      },
      {
        "kind": "Literal",
        "name": "status",
        "value": [
          "draft"
        ]
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "name": "title"
          },
          {
            "concreteType": "ContentBodyPerRepresentation",
            "kind": "LinkedField",
            "name": "body",
            "plural": false,
            "selections": [
              {
                "concreteType": "ContentBody",
                "kind": "LinkedField",
                "name": "atlas_doc_format",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "value"
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "name": "key"
              },
              {
                "kind": "ScalarField",
                "name": "alias"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "SmartCreatePageEditorDataWrapperComponentQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SmartCreatePageEditorDataWrapperComponentQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "c0a7532c77f00a6d3db89afbba6c2124",
    "id": "e3afe4be4952ff1385de921ea89e96ad689b38bd27c628e4ceacc511c99519eb",
    "metadata": {},
    "name": "SmartCreatePageEditorDataWrapperComponentQuery",
    "operationKind": "query",
    "text": "query SmartCreatePageEditorDataWrapperComponentQuery($contentId:ID!){content(id:$contentId,status:[\"draft\"]){nodes{id,title,body{atlas_doc_format{value}},space{id,key,alias}}}}"
  }
};
})();

(node as any).hash = "1aa5e1f3fdc665522f842f14ed2e0264";

export default node;
